import React from 'react';
import { useNavigate } from 'react-router-dom';
import './AGIndustries.css';

const embajadoras = [
  {
    nombre: 'Ana Namor-Rusia',
   img: '/IMG5-EMBAJADORAS.jpeg',
  },
  {
    nombre: 'Vianny Alvarado - Venezuela',
    img: '/IMG3-EMBAJADORAS.jpeg',
  },
  {
    nombre: 'Simona Traykova - Bulgaria',
    img: '/IMAG4-EMBAJADORAS.jpeg',
  },
];

const Embajadoras = () => {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div className="sx-wrapper">
      <div className="sx-video-bg">
        <video autoPlay muted loop playsInline webkit-playsinline="true" x5-playsinline="true" className="sx-video">
          <source src="/Vino1.mp4" type="video/mp4" />
        </video>
        <div className="sx-video-overlay" />
      </div>

      <header className={`sx-header ${scrolled ? 'scrolled' : ''}`}
        style={{ alignItems: 'flex-start', paddingTop: '13px' }}>
        <button
          onClick={() => navigate('/')}
          className="sx-back-btn"
          style={{
            background: 'none', border: 'none', color: '#fff',
            cursor: 'pointer', fontSize: '22px', opacity: 0.75,
            transition: 'opacity 0.3s ease', padding: '6px',
            marginLeft: '4px', marginTop: '1px', display: 'flex',
            alignItems: 'center', justifyContent: 'center'
          }}
          onMouseEnter={e => e.currentTarget.style.opacity = 1}
          onMouseLeave={e => e.currentTarget.style.opacity = 0.75}
          aria-label="Volver"
        >
          &#8592;
        </button>
        <span className="sx-registrate-label" style={{ position: 'absolute', left: '50%', transform: 'translateX(-50%)', fontFamily: 'Georgia, serif', fontSize: '15px', letterSpacing: '0.31em', textTransform: 'uppercase', color: '#fff', zIndex: 1001, opacity: 0.9 }}>Embajadoras</span>
        <div className="sx-header-right" />
      </header>

      <div style={{
        position: 'relative', zIndex: 10,
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        minHeight: '100', padding: '100px 24px 60px',
        gap: '40px'
      }}>
        <div style={{
          display: 'flex', flexWrap: 'wrap',
          gap: '24px', justifyContent: 'center',
          width: '100%', maxWidth: '900px'
        }}>
          {embajadoras.map((e, i) => (
           <div key={i} className="embajadora-card" style={{
           display: 'flex', flexDirection: 'column',
           alignItems: 'center', gap: '12px',
           flex: '1 1 240px', maxWidth: '280px'
           }}>
              <img
                src={e.img}
                alt={e.nombre}
                style={{
                  width: '100%', aspectRatio: '3/4',
                  objectFit: 'cover', borderRadius: '2px',
                  filter:'none'
                }}
              />
              <p style={{
                fontFamily: 'Georgia, serif', fontSize: '14px',
                letterSpacing: '0.15em', color: '#fff',
                opacity: 0.9,
                textAlign: 'center', textTransform: 'uppercase'
              }}>{e.nombre}</p>
              <p style={{
                fontFamily: 'Georgia, serif', fontSize: '11px',
                letterSpacing: '0.1em', color: '#fff',
                opacity: 0.9,
                textAlign: 'center'
              }}>{e.titulo}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Embajadoras;